// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__F4XQA","download_button":"styles_download_button__-15jO","download_multiple_button":"styles_download_multiple_button__v2ybW"};